import { getAccessToken } from '@lidea/shared/util/local-storage';
import { useQuery } from '@tanstack/react-query';

import { usersApi } from '../../apis/users-api';
import { userKeys } from '../../keys/user-keys';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface UseMeProps {
  enabled?: boolean;
}

export function useMe(props?: UseMeProps) {
  const hasToken = !!getAccessToken();
  const query = useQuery({
    queryKey: userKeys.me(),
    queryFn: () => usersApi.me(),
    enabled: props?.enabled !== false && hasToken,
  });

  return query;
}

export default useMe;
